// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.loading-icon[data-v-2173043a]{min-height:240px}ul.options[data-v-2173043a]{padding-top:10px;padding-bottom:5px}ul.options[data-v-2173043a] .avatar{padding:0 .5em}@media(max-width: 512px){ul.options[data-v-2173043a]{font-size:.9em}}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
